import InitialState from "./InitialState"
import { GET_IS_ACTIVE_COVID_PACK } from "../actions/ActionTypes"

export const CovidReducer = function (initialState = InitialState.covidInfo, action: any) {
  switch (action.type) {
    case GET_IS_ACTIVE_COVID_PACK:
      const payload = action.payload;
      let isCovidActivePack = false;
      if (payload && Array.isArray(payload)) {
        isCovidActivePack = !!payload.find((pack: any) => {
          return pack.productCode === "COVID-HOME-MONITORING-ADVANCED" || pack.productCode === "COVID-HOME-MONITORING-BASIC";
        });
      }
      return {
        isCovidActivePack
      };
    default:
      return initialState;
  }
}